import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { AtLeastAdvisorRoleGuard } from '@next/core-lib/authorization';
import { LocationGuard } from '@next/core-lib/relationships';

import { CreateReferenceSchemeComponent } from './components/create-reference-scheme/create-reference-scheme.component';
import { ReferenceSchemeOverviewComponent } from './components/reference-scheme-overview/reference-scheme-overview.component';
import { ReferenceSchemeRouterComponent } from './components/reference-scheme-router/reference-scheme-router.component';
import { GetReferenceSchemeByIdResolver } from './resolvers/get-reference-scheme-by-id.resolver';
import { ReferenceSchemeOverviewResolver } from './resolvers/reference-scheme-overview.resolver';

const referenceSchemeFeatureRoutes: Routes = [
  {
    path: '',
    component: ReferenceSchemeOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve(ReferenceSchemeOverviewResolver),
    },
  },
  {
    path: 'create',
    component: CreateReferenceSchemeComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    resolve: {
      data: mapToResolve(ReferenceSchemeOverviewResolver),
    },
  },
  {
    path: 'edit/:id',
    component: CreateReferenceSchemeComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    resolve: {
      referenceScheme: mapToResolve(GetReferenceSchemeByIdResolver),
    },
  },
  {
    path: 'view/:id',
    component: CreateReferenceSchemeComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      referenceScheme: mapToResolve(GetReferenceSchemeByIdResolver),
    },
  },
];

export const referenceSchemeRoutes: Routes = [
  {
    path: 'reference-scheme',
    component: ReferenceSchemeRouterComponent,
    children: referenceSchemeFeatureRoutes,
  },
];
